import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Observable, map } from 'rxjs';
import { FileStoreService } from '../../../../../shared/services/filestore.service';

@Component({
  selector: 'app-echo',
  template: `<div class="container">
    @if (fileContent$ | async; as fileContent) {
      <div class="flex flex-col gap-4">
        <div class="markdown" [innerHTML]="fileContent | echoMarkdown"></div>
      </div>
    } @else {
      <app-loader></app-loader>
    }
  </div>`,
  styles: [
    `
      .container {
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  standalone: false,
})
export class ExpertEchoComponent implements OnInit, OnChanges {
  @Input() fileKey: string;

  fileContent$: Observable<string>;

  constructor(private fileStoreService: FileStoreService) {}

  ngOnInit() {
    this.fileContent$ = this.fileStoreService
      .getFileContent(this.fileKey)
      .pipe(map((fileContent) => fileContent.replace(/^#\s.*$/gm, '').trim()));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fileKey) {
      this.fileContent$ = this.fileStoreService
        .getFileContent(this.fileKey)
        .pipe(
          map((fileContent) => fileContent.replace(/^#\s.*$/gm, '').trim())
        );
    }
  }
}
